import { render } from "./UnauthenticatedUserFollowProjectEmailConfirmation.vue?vue&type=template&id=10db8c02"
import script from "./UnauthenticatedUserFollowProjectEmailConfirmation.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedUserFollowProjectEmailConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__